import { NgModule } from "@angular/core";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

export function createTranslateLoader(http: HttpClient) {
	return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

import {
	HeaderBarModule,
	AccordionModule,
	BasicHeaderModule,
	BreadcrumbModule,
	CardGroupModule,
	CardModule,
	CollapseModule,
	ContentBlockModule,
	DatepickerModule,
	FileuploadModule,
	FooterbarModule,
	FormModule,
	HeaderModule,
	ListModule,
	LoadingSpinnerModule,
	MessageModule,
	OverlayModule,
	PageHeaderModule,
	PaginationModule,
	PopoverModule,
	ScrollableModule,
	TableElementsModule,
	TableModule,
	TabViewModule,
	TimepickerModule,
	TooltipModule
} from 'rb-core-library';
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

const MODULES = [
	HeaderBarModule,
	AccordionModule,
	BasicHeaderModule,
	BreadcrumbModule,
	CardModule,
	CardGroupModule,
	CollapseModule,
	ContentBlockModule,
	DatepickerModule,
	FileuploadModule,
	FooterbarModule,
	FormModule,
	HeaderModule,
	ListModule,
	LoadingSpinnerModule,
	MessageModule,
	OverlayModule,
	PageHeaderModule,
	PaginationModule,
	PopoverModule,
	ScrollableModule,
	TabViewModule,
	TableElementsModule,
	TableModule,
	TooltipModule,
	TimepickerModule
];


@NgModule({
	imports: [
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: createTranslateLoader,
				deps: [HttpClient]
			}
		}),
        HttpClientModule,
		...MODULES
	],
	exports: [
		TranslateModule,
		FormsModule,
        CommonModule,
        RouterModule,
		...MODULES
	]
})
export class SharedModule { }
